import React, { memo } from 'react'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Box, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui'
import { capitalize } from 'utils/capitalize'
import { CollapsibleSection } from '../../CollapsibleSection'
import { ValueField } from '../../ValueField'
import { useContactInformationQuery } from './graphql/ContactInformationAddressList'
import { getStreet } from './utils'

interface IContactInformationAddressListProps {
  carrierId: string
}

export const ContactInformationAddressList = memo<IContactInformationAddressListProps>(
  ({ carrierId }) => {
    const { data, error, loading } = useContactInformationQuery({
      variables: { carrierApplicationId: carrierId },
    })

    const { highwayCarrier } = data || {}
    const { addresses = [] } = highwayCarrier || {}

    const Title = () => <Typography variant='subtitle1'>Addresses</Typography>

    return (
      <CollapsibleSection Title={Title}>
        {error && <InlineMessage message={error.message} type={INLINE_MESSAGE_VARIANTS.ALERT} />}
        {addresses?.map(
          ({ city, countryCode, id, isType, postalCode, stateCode, street1, street2 }, i) => (
            <Box
              key={id}
              display='grid'
              gridTemplateColumns='1fr 1fr'
              gap='12px'
              borderBottom={
                i === addresses.length - 1 ? 'none' : `1px solid ${brandColors.coolGray2}`
              }
              mb='8px'
              pb='8px'>
              <ValueField title='Address Type' value={capitalize(isType)} loading={loading} />
              <ValueField
                title='City'
                value={city && stateCode ? `${city}, ${stateCode}` : ''}
                loading={loading}
              />
              <ValueField title='Country' value={countryCode} loading={loading} />
              <ValueField
                title='Billing Address'
                value={getStreet(street1, street2)}
                loading={loading}
              />
              <div />
              <ValueField title='Billing Zip' value={postalCode} loading={loading} />
            </Box>
          )
        )}
      </CollapsibleSection>
    )
  }
)
